import React from 'react';
// TODO: replace with v2 Icon when migrated (see Follow up in TAN-7271).
import { Icon } from 'ui';
import { VALIDATION_CONFIG, ValidationType } from './validationConfig';

type ValidationMessageProps = {
  id?: string;
  text: string;
  type: ValidationType;
};

function FormValidationMessage({ id, text, type }: ValidationMessageProps): JSX.Element {
  const config = VALIDATION_CONFIG[type];

  return (
    <span id={id} className={`validation-message validation-message--${type}`} role="status">
      <Icon type={config.messageIcon} size="xs" color={config.color} />
      {text}
    </span>
  );
}

export default FormValidationMessage;
